import React, { useState } from 'react';
import { getCookie } from '../utils';

export default function CreatePool({ fetchPools, setActiveTab, setSelectedPoolId, poolToEdit }) {
  const isEdit = !!poolToEdit;
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    
    const facilitiesArray = formData.get('facilities').split(',').map(f => f.trim()).filter(f => f);
    const selectedPrograms = formData.getAll('programs');
    
    if (selectedPrograms.length === 0) return alert("Please select at least one program.");

    setIsSubmitting(true);

    const apiPayload = {
      Name: formData.get('name'),
      Title: formData.get('title'),
      Capacity: Number(formData.get('capacity')), // NEW: Capture capacity as a Number
      // picUrl: formData.get('pic') || 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=600',
      Address: formData.get('address'),
      Facilities: facilitiesArray,
      mapsURL: formData.get('mapUrl'),
      programs: selectedPrograms,
      active: formData.get('isActive') === 'on' 
    };

    try {
      const token = getCookie('tsa_token');
      const apiHeaders = {
        'Content-Type': 'application/json',
        'x-auth-token': token || ''
      };

      if (isEdit) {
        const poolId = poolToEdit._id || poolToEdit.id; 
        const response = await fetch(`https://tsaapis.operate.live/api/pools/${poolId}`, {
          method: 'PUT',
          headers: apiHeaders,
          credentials: 'include',
          body: JSON.stringify(apiPayload)
        });

        if (!response.ok) throw new Error("Failed to update pool in database");

        await fetchPools(); 
        alert("Pool Updated Successfully!");

      } else {
        const response = await fetch('https://tsaapis.operate.live/api/pools', {
          method: 'POST',
          headers: apiHeaders,
          credentials: 'include',
          body: JSON.stringify(apiPayload)
        });

        if (!response.ok) throw new Error("Failed to save pool to database");
        
        const savedData = await response.json(); 

        await fetchPools();
        
        if (savedData && savedData._id) {
            setSelectedPoolId(savedData._id); 
        }
        
        alert("New Pool Added Successfully!");
      }
      
      setActiveTab('programs');
    } catch (error) {
      console.error("API Error:", error);
      alert("Something went wrong saving the pool. Please check the console and try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const isPoolActive = isEdit && poolToEdit.isActive !== undefined ? poolToEdit.isActive : true;

  return (
    <div className="admin-card">
      <h2>
        <span>{isEdit ? 'Edit Pool' : 'Add New Pool'}</span>
        <button className="btn-small" onClick={() => setActiveTab('programs')} disabled={isSubmitting}>
          <i className="fas fa-arrow-left"></i> Cancel
        </button>
      </h2>
      <form onSubmit={handleSave}>

        <div className="form-grid">

          <div className="form-group">
            <label>Pool Name</label>
            <input type="text" name="name" defaultValue={poolToEdit?.name || poolToEdit?.Name} placeholder="e.g. Indiranagar Center" required disabled={isSubmitting} />
          </div>

          <div className="form-group" style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <label>Descriptive Title</label>
              <input type="text" name="title" defaultValue={poolToEdit?.title || poolToEdit?.Title} placeholder="e.g. 50m Olympic Sized Pool" required disabled={isSubmitting} />
            </div>
            <div style={{ paddingTop: '28px' }}>
              <label className="weekday-label" style={{ padding: '10px 20px', cursor: 'pointer', margin: 0, display: 'inline-flex', alignItems: 'center' }}>
                <input type="checkbox" name="isActive" defaultChecked={isPoolActive} disabled={isSubmitting} />
                <span style={{ marginLeft: '5px' }}>Active</span>
              </label>
            </div>
          </div>

          {/* NEW: Capacity Field */}
          <div className="form-group full-width">
            <label>Pool Capacity (Max Swimmers)</label>
            <input 
              type="number" 
              name="capacity" 
              defaultValue={poolToEdit?.Capacity || poolToEdit?.capacity || 50} 
              placeholder="e.g. 50" 
              required 
              disabled={isSubmitting} 
              min="1" 
            />
          </div>

          <div className="form-group full-width">
            <label>Address</label>
            <input type="text" name="address" defaultValue={poolToEdit?.address || poolToEdit?.Address} placeholder="Full physical address" required disabled={isSubmitting} />
          </div>
          
          <div className="form-group full-width">
            <label>Facilities (Comma separated)</label>
            <input type="text" name="facilities" defaultValue={poolToEdit?.facilities?.join(', ') || poolToEdit?.Facilities?.join(', ')} placeholder="e.g. Showers, Lockers, Parking, Heated" required disabled={isSubmitting} />
          </div>
          
          <div className="form-group full-width">
            <label>Google Maps URL</label>
            <input type="url" name="mapUrl" defaultValue={poolToEdit?.mapUrl || poolToEdit?.mapsURL} placeholder="https://maps.google.com/..." required disabled={isSubmitting} />
          </div>

          <div className="form-group full-width">
            <label>Programs Offered</label>
            <div className="weekdays-container">
              {['Group Training', 'Personal Training', 'Premium Membership', 'Pay and Use Pool'].map(prog => (
                <label key={prog} className="weekday-label">
                  <input type="checkbox" name="programs" value={prog} defaultChecked={isEdit ? poolToEdit.programs?.includes(prog) : false} disabled={isSubmitting} /> {prog}
                </label>
              ))}
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            <i className={isSubmitting ? "fas fa-spinner fa-spin" : "fas fa-save"}></i>
            {isSubmitting ? ' Saving...' : (isEdit ? ' Update Pool' : ' Save Pool')}
          </button>
        </div>

      </form>
    </div>
  );
}